/* eslint no-restricted-syntax:0 */
import { webviewInfo } from '@ali/amap-lib';

const LINKURL = {}; // output
const linkURL = {
  // 注意此处https
  index: {
    test: 'https://testing.amap.com/activity/2020TaxiGetNew/index.html',
    public: 'https://cache.amap.com/activity/2020TaxiGetNew/index.html'
  },
  pricecomparison: {
    test: 'https://testing.amap.com/activity/2020TaxiGetNew/pricecomparison.html',
    public: 'https://cache.amap.com/activity/2020TaxiGetNew/pricecomparison.html'
  },
  // download页面
  download: {
    test: 'https://testing.amap.com/activity/2020TaxiGetNew/download.html',
    public: 'https://cache.amap.com/activity/2020TaxiGetNew/download.html'
  },
  // 注意此处http
  callNative: {
    test: 'http://testing.amap.com/activity/2020TaxiGetNew/callNative.html',
    public: 'http://cache.amap.com/2020TaxiGetNew/callNative.html'
  },
  // 我的奖品,AmapApp.util.goAward()
  awardlist: {
    test: '//group.testing.amap.com/public/activity/common/page/awardlist.html',
    public: '//cache.amap.com/activity/common/page/awardlist.html'
  },
  /*  其他接口 */
};

const ONLINE_HOST = `${window.location.protocol}//wap.amap.com`;
const DEBUG_HOST = `${window.location.protocol}//group.testing.amap.com/public`;
const HOST = !webviewInfo.isPublic() ? DEBUG_HOST : ONLINE_HOST;
for (const k in linkURL) {
  if (linkURL[k].test) {
    const url = (!webviewInfo.isPublic() ? linkURL[k].test : linkURL[k].public);
    if (url.indexOf('http') !== -1) { // 如果写了http，那么就用写的协议，否则以页面当前协议拼接
      LINKURL[k] = url;
    } else {
      LINKURL[k] = window.location.protocol + url;
    }
  } else {
    LINKURL[k] = `${HOST}/${linkURL[k]}`;
  }
}

export default LINKURL;
